import { render, staticRenderFns } from "./Dashboard_en.vue?vue&type=template&id=cba452a2&"
import script from "./Dashboard_en.vue?vue&type=script&lang=js&"
export * from "./Dashboard_en.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_en.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports